module.exports = __webpack_public_path__ + "media/images/torn-paper-d09b3f065a904531be0b99a777ffb494.png";